module.exports = __webpack_public_path__ + "img/qy (54).045488a0.jpg";